import React, { useEffect, useCallback } from 'react';
import { Icon } from '@ohif/ui';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {
  useTable,
  useRowSelect,
  useResizeColumns,
  useFlexLayout,
  useExpanded,
} from 'react-table';
import Popover from 'react-popover';
import CreatableSelect from 'react-select/creatable';
import { getAiResultSearchByI2d } from './makeData';

const Styles = styled.div`
  display: block;
  background: #21294a;
  max-width: 100%;
  min-height: 100%;
  .tableWrap {
    display: block;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    border-bottom: 1px solid black;
  }
  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid black;
    tr {
      align-items: center;
      color: #fff;
      flex-wrap: wrap;
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: none;
      height: 37px;

      :last-child {
        border-right: 0;
      }
    }
  }
`;

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input
          type="checkbox"
          style={{
            zIndex: '9999',
          }}
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

function Table({
  columns,
  data,
  orderData,
  checked,
  filters,
  ids,
  expandeds,
  aiCheckId,
  aiInfoId,
  getClickTextareaChange,
  getFiltersChange,
  getRowValue,
  // getRowProps,
}) {
  // Use the state and functions returned from useTable to build your UI

  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [isOrderDialogOpen, setIsOrderDialogOpen] = React.useState(false);
  const [options, setOptions] = React.useState(filters);
  const [selectValue, setSelectValue] = React.useState([]);

  /*******************************筛选和排序部分数据 **********************/
  const [isQuery, setIsQuery] = React.useState(false);
  const [searchKey, setSearchKey] = React.useState();
  const [originLength, setOriginLength] = React.useState(0);
  const [filterArr] = React.useState(filters);
  // const [idxs, setIdxs] = React.useState(ids);
  const [currtntOrder, setCurrentOrder] = React.useState('');
  const [currtntFilter, setCurrtntFilter] = React.useState([]);
  // const [isChecked, setIsChecked] = React.useState(false);
  // const colourOptions = filters;

  useEffect(() => {
    if (isQuery) {
      getAiResultSearchByI2d({
        aiCheckId: aiCheckId,
        aiInfoId: aiInfoId,
        searchKey: searchKey.value,
        // orderKey: currtntOrder,
      }).then(res => {
        if (res.data && res.data.length > 0) {
          let arr = res.data.map((i, idx) => {
            return { value: i, label: i, pid: searchKey.rid };
          });
          setOptions(arr);
        } else {
          setOptions([]);
        }
      });
    }
  }, [aiCheckId, aiInfoId, isQuery, searchKey]);

  const handleChange = e => {
    setSelectValue(e);
    if (e && e.length > 0) {
      let index = e.length - 1;
      if (e.length > originLength) {
        setOriginLength(e.length);
        if (e && e[index].pid === 0) {
          setSearchKey(e[index]);
          setIsQuery(true);
        } else {
          let key = filterArr.filter(f => f.rid === e[index].pid)[0].value;
          let keyword = [];
          e.filter(f => f.pid !== 0).map(item => {
            keyword.push(item.label);
          });
          // console.log([{ key: key, value: keyword.toString() }]);
          setCurrtntFilter([{ key: key, value: keyword.toString() }]);
          getFiltersChange(
            currtntOrder,
            [{ key: key, value: keyword.toString() }],
            [],
            []
          );
        }
      } else {
        setOriginLength(e.length);
        if (e.length > 1) {
          let key = filterArr.filter(f => f.rid === e[index].pid)[0].value;
          let keyword = [];
          e.filter(f => f.pid !== 0).map(item => {
            keyword.push(item.label);
          });
          setCurrtntFilter([{ key: key, value: keyword.toString() }]);
          getFiltersChange(
            currtntOrder,
            [{ key: key, value: keyword.toString() }],
            [],
            []
          );
          // console.log([{ key: key, value: keyword.toString() }]);
        } else {
          setCurrtntFilter([]);
          setIsQuery(false);
        }
      }
    } else {
      setOriginLength(0);
      setCurrtntFilter([]);
      getFiltersChange(currtntOrder, [], [], []);
      setOptions(filters);
    }
  };

  const customStyles = {
    indicatorSeparator: () => null, // removes the "stick"

    menu: base => ({
      ...base,
      backgroundColor: '#556472',
    }),
    menuList: base => ({
      ...base,
      color: '#fff',
      // backgroundColor: '#556472',
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#fff',
      backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
    }),
    control: () => ({
      color: '#fff',
      width: '300px',
      // height: '40px',
      alignItems: 'center',
      display: 'flex',
      backgroundColor: '#fff',
      borderRadius: 6,
      margin: 0,
    }),
  };

  const menuHeaderStyle = {
    padding: '8px 20px',
    background: '#2C363F',
    cursor: 'pointer',
    color: '#91B9CD',
    display: 'flex',
    alignItems: 'center',
  };

  const MenuList = props => {
    if (searchTip === 0) {
      return (
        <>
          <components.MenuList {...props}>
            <div> </div>
            {props.children}
          </components.MenuList>
        </>
      );
    }
    if (searchTip === 1) {
      return (
        <components.MenuList {...props}>
          <div style={menuHeaderStyle} onClick={returnSup}>
            <img
              style={{
                marginRight: '10px',
              }}
              height="16"
              width="18"
              src={
                'https://yinghe-pacs.oss-cn-hangzhou.aliyuncs.com/viewer/angle-double-left.png'
              }
              alt=""
            />
            选择其它筛选条件
          </div>
          {props.children}
        </components.MenuList>
      );
    }
  };

  const MultiValueRemove = props => {
    if (props.data.pid === 0) {
      return (
        <components.MultiValueRemove
          {...props}
          style={{
            width: '0px',
          }}
        >
          <div></div>
        </components.MultiValueRemove>
      );
    } else {
      return (
        <components.MultiValueRemove {...props}>
          <img
            height="16"
            width="16"
            src={
              'https://yinghe-pacs.oss-cn-hangzhou.aliyuncs.com/viewer/close.png'
            }
            alt=""
          />
        </components.MultiValueRemove>
      );
    }
  };

  const popoverProps = {
    isOpen: isDialogOpen,
    preferPlace: 'left',
    place: 'end',
    onOuterAction: () => togglePopover(false),
    body: [
      <CreatableSelect
        styles={customStyles}
        // onBlur={onBlur}
        // onFocus={onFocus}
        // menuIsOpen={menuIsOpen}
        // components={{ MenuList, MultiValueRemove }}
        key={'screen'}
        placeholder={'请选择筛选条件'}
        isMulti
        value={selectValue}
        options={options}
        onChange={handleChange}
      />,
    ],
  };

  const popoverPropsOrder = {
    isOpen: isOrderDialogOpen,
    preferPlace: 'left',
    place: 'end',
    onOuterAction: () => toggleOrderPopover(false),
    body: [
      <div className="order" key={'order'}>
        {orderData.map((item, idx) => (
          <div
            key={idx}
            className={currtntOrder === item ? 'list active' : 'list'}
            onClick={e => orderChange(e)}
          >
            {item}
          </div>
        ))}
      </div>,
    ],
  };

  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 30,
      width: 130,
      maxWidth: 150,
    }),
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    toggleAllRowsSelected,
    toggleRowExpanded,
    // headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    // checkedValue,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      initialState: { selectedRowIds: ids },
    },
    useExpanded, // Use the useExpanded plugin hook
    useResizeColumns,
    useFlexLayout,
    useRowSelect,
    hooks => {
      hooks.visibleColumns.push(columns => [
        {
          id: 'selection',
          minWidth: 35,
          width: 35,
          maxWidth: 35,
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),

          Cell: ({ row }) =>
            row.canExpand ? (
              <span>
                <div>
                  <IndeterminateCheckbox
                    {...row.getToggleRowSelectedProps()}
                    onClick={e => {
                      getClickTextareaChange(row, []);
                      e.stopPropagation();
                    }}
                  />
                </div>
              </span>
            ) : null,
        },
        ...columns,
      ]);
    }
  );

  const handleAllRowsSelected = e => {
    toggleAllRowsSelected(e.target.checked);
    getClickTextareaChange(e.target.checked, data);
    // getClickTextareaChange(e.target.checked, selectedFlatRows)
  };

  const togglePopover = e => {
    const popoverIsOpen = typeof e === 'boolean' ? e : !isDialogOpen;
    setIsDialogOpen(popoverIsOpen);
  };

  const toggleOrderPopover = e => {
    const popoverOrderIsOpen = typeof e === 'boolean' ? e : !isOrderDialogOpen;
    setIsOrderDialogOpen(!isOrderDialogOpen);
  };

  const orderChange = useCallback(
    e => {
      let arr = [];
      if (selectedFlatRows.length > 0) {
        selectedFlatRows.map(item => {
          arr.push(item.original.detailId);
        });
      }
      if (e === currtntOrder) {
        setCurrentOrder('');
        getFiltersChange('', currtntFilter, expandeds, arr);
      } else {
        setCurrentOrder(e.currentTarget.textContent);
        getFiltersChange(
          e.currentTarget.textContent,
          currtntFilter,
          expandeds,
          arr
        );
      }
      setIsOrderDialogOpen(false);
    },
    [currtntFilter, currtntOrder, expandeds, getFiltersChange, selectedFlatRows]
  );

  const customRowSelectd = row => {
    toggleRowExpanded(row.index, !row.isExpanded);
    getRowValue(row);
  };

  // Render the UI for your table
  return (
    <>
      <div className="analysis-header">
        <div
          style={{
            display: 'flex',
          }}
        >
          <div className="all">
            <input
              type="checkbox"
              checked={checked}
              onClick={handleAllRowsSelected}
              readOnly
            />
            全选{expandeds.length}/{data.length}
          </div>
          {/* <div className="all">
                        <input type="checkbox" />显示≤3.0mm的结节（15）
                    </div> */}
        </div>

        <div
          style={{
            display: 'flex',
          }}
        >
          <Popover {...popoverPropsOrder}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: '10px',
              }}
              onClick={toggleOrderPopover}
            >
              <Icon width="16px" height="20px" name={'order'} />
            </div>
          </Popover>
          <Popover {...popoverProps}>
            <div
              style={{ display: 'flex', alignItems: 'center' }}
              onClick={togglePopover}
            >
              <Icon width="20px" height="27px" name={'screen'} />
            </div>
          </Popover>
        </div>
      </div>
      {data.length ? (
        <table {...getTableProps()}>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr
                  key={i}
                  {...row.getRowProps({ onClick: () => customRowSelectd(row) })}
                >
                  {row.cells.map((cell, idx) => {
                    return (
                      <td key={idx} {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="result">未见明显异常</div>
      )}
    </>
  );
}
Table.propTypes = {
  columns: PropTypes.any,
  data: PropTypes.any,
  orderData: PropTypes.array,
  filters: PropTypes.any,
  checked: PropTypes.any,
  ids: PropTypes.any,
  expandeds: PropTypes.any,
  aiCheckId: PropTypes.any,
  aiInfoId: PropTypes.any,
  getClickTextareaChange: PropTypes.any,
  getFiltersChange: PropTypes.any,
  getRowValue: PropTypes.any,
  getRowProps: PropTypes.any,
};

function SubList({
  data,
  orderData,
  filters,
  getClickTextareaChange,
  checked,
  ids,
  expandeds,
  aiCheckId,
  aiInfoId,
  getFiltersChange,
  getRowValue,
}) {
  const columns2 = React.useMemo(
    () => [
      {
        Header: 'Info',
        columns: [
          {
            Header: '序号',
            accessor: 'index',
            width: '30',
          },
          {
            Header: 'name',
            accessor: 'name0',
          },
          {
            Header: 'name',
            accessor: 'name1',
          },
          {
            Header: 'name',
            accessor: 'name2',
          },
        ],
      },
    ],
    []
  );

  const clickTextareaChange = (data, ds) => {
    getClickTextareaChange(data, ds);
  };

  const filtersChange = (e, f, t, d) => {
    getFiltersChange(e, f, t, d);
  };

  const rowValue = e => {
    getRowValue(e);
  };

  return (
    <Styles>
      <Table
        getClickTextareaChange={clickTextareaChange}
        getFiltersChange={filtersChange}
        getRowValue={rowValue}
        columns={columns2}
        data={data}
        orderData={orderData}
        aiCheckId={aiCheckId}
        aiInfoId={aiInfoId}
        filters={filters}
        checked={checked}
        ids={ids}
        expandeds={expandeds}
      />
    </Styles>
  );
}
SubList.propTypes = {
  columns: PropTypes.any,
  data: PropTypes.any,
  orderData: PropTypes.any,
  filters: PropTypes.any,
  getClickTextareaChange: PropTypes.any,
  checked: PropTypes.any,
  ids: PropTypes.any,
  expandeds: PropTypes.any,
  aiCheckId: PropTypes.any,
  aiInfoId: PropTypes.any,
  getFiltersChange: PropTypes.any,
  getRowValue: PropTypes.any,
};
export default SubList;
